export default __webpack_public_path__ + "static/media/ic-mediumBlack.04b2213f.svg";